import {
  Button as _Button,
  COLOR,
  FONT_SIZE,
  mq,
  Heading as _Heading,
  FONT_WEIGHT,
} from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const HeadingBold = styled(_Heading)`
  font-weight: ${FONT_WEIGHT.BOLD};
`;

export const DivRootPurchaseList = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px 0;
  border-bottom: 1px solid ${COLOR.GRAY200.code};

  ${mq.sp} {
    display: grid;
    grid-gap: 16px;
    grid-template-columns: 1fr;
  }
`;

export const ParLimitedPremiumText = styled.p`
  font-size: ${FONT_SIZE.S}px;
  color: ${COLOR.YELLOW50.code};
  font-weight: ${FONT_WEIGHT.BOLD};
`;

export const SecPurchaseListItem = styled.section`
  display: grid;
  grid-gap: 8px;
  padding-right: 16px;
  width: 60%;

  ${mq.sp} {
    width: 100%;
    padding-right: 0px;
  }
`;

export const SectionDescription = styled.section`
  font-size: ${FONT_SIZE.XS}px;
  color: ${COLOR.GRAY500.code};
`;

export const ParPurchasedText = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${COLOR.GRAY500.code};
  font-size: ${FONT_SIZE.M}px;
  font-weight: ${FONT_WEIGHT.BOLD};
  width: 40%;

  ${mq.sp} {
    width: auto;
    font-size: ${FONT_SIZE.S}px;
  }
`;

export const ButtonPurchaseOrRental = styled(_Button)`
  width: 40%;
  font-size: 16px;

  ${mq.sp} {
    width: auto;
    font-size: 14px;
  }
`;
